import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "WLGPI",
  title: defineMessage({
    id: "fig.equity.WLGPI.title",
    defaultMessage: `Parity index for selected indicators and characteristicsss`,
  }),
  caption: defineMessage({
    id: "fig.equity.WLGPI.caption",
    defaultMessage: `Disparity accumulates over the course of the education trajectory at the expense of the poorest children.`,
  }),
  source: defineMessage({
    id: "fig.equity.WLGPI.source",
    defaultMessage: `GEM Report team analysis based on household surveys`,
  }),
};
